import TheGrid from '@/views/zipcodes/grid'
import Edit from '@/views/zipcodes/edit'
import TheView from '@/views/zipcodes/view'

export default {
  path: '/zipcodes',
  redirect: '/zipcodes/index',
  name: 'zipcodes',
  meta: {
    auth: {
      redirect: {
        name: 'zipcodes.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Regiões'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'zipcodes.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'zipcodes.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'zipcodes.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }, {
    path: 'view/:id',
    name: 'zipcodes.view',
    component: TheView,
    meta: {
      auth: true,
      label: 'Ver'
    }
  }]
}
